import { IChecklistItem, IDocument } from 'src/shared/types/Documents';

export const isChecklistItemComplete = (checklistItem: IChecklistItem): boolean => {
  if (checklistItem.isShowing === true) {
    if (
      checklistItem.checklistItemDocuments !== undefined &&
      checklistItem.checklistItemDocuments.length > 0 &&
      checklistItem.checklistItemGroups !== undefined &&
      (checklistItem.checklistItemGroups ?? []).length === 0
    ) {
      return true;
    } else if ((checklistItem.checklistItemGroups ?? []).length > 0) {
      const filteredPassports = (checklistItem.checklistItemGroups ?? []).filter(
        (i) => (i.checklistItemDocuments?.length ?? 0) > 0
      );

      if (filteredPassports.length === 0) return false;

      return filteredPassports.every((item) => item.passportInfoId !== null);
    }
  }

  return false;
};

export const DOCUMENT_TYPE_NAME = {
  PASSPORT: 'Passport',
  OTHER: 'Other',
  BUNDLE: 'Bundle',
  GOVERNMENT_IMMIGRATION_DOCUMENT: 'Government Immigration Document',
};

export const buildChecklistDocumentName = (input: {
  fileName?: string;
  applicantName?: string;
  documentTypeName?: string;
}) => {
  const separator = ' - ';
  const checklistDocumentName = [input.fileName, input.applicantName, input.documentTypeName]
    .map((x) => x?.trim())
    .filter((x) => !!x)
    .join(separator);
  return truncateChecklistDocumentNameIfNeeded(checklistDocumentName);
};

const truncateChecklistDocumentNameIfNeeded = (docName: string = '') => {
  const maxCharacters = 500;
  return docName.substring(0, maxCharacters);
};
